import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useSelector } from 'src/store/store';
import { Poll } from 'src/constants/types';

type resultProps = {
  title: string;
  votes: number;
}
export default function PollResult({ title, votes }: resultProps) {
  const { highestVote: max } = useSelector((state) => state.pages.singlePost.post as Poll);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <Result>
      <BarContainer>
        <Bar animate={animate} max={max} votes={votes} />
        <Votes>{votes}</Votes>
      </BarContainer>
      <Title>{title}</Title>
    </Result>
  );
}

const Result = styled.div`
  width: 100%;
`;
const BarContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin: 15px 0 5px;
`;
const Bar = styled.div<{ animate: boolean, votes: number, max: number }>`
  transition: width .3s ease-in-out .2s;
  width: ${props => props.animate && props.votes / props.max * 100 || 1}%;
  height: 30px;
  background-color: ${({ theme }) => theme.colorPink};
  border-radius: 0 5px 5px 0;
`;
const Votes = styled.span`
  margin-left: 10px;
`;
const Title = styled.div`
  word-wrap: break-word;
`;
